import 'fullpage.js/dist/jquery.fullpage.js';

const selectors = {
    sections: '.js-section',
    arrowTop: '.js-arrow-navigation-top',
    arrowTopLink: '.js-arrow-navigation-top-link',
    arrowBottom: '.js-arrow-navigation-bottom',
    arrowBottomLink: '.js-arrow-navigation-bottom-link',
    splash: '.js-splash',
    normalScrollItem: '.js-fullpage-normal-scroll-element'
};

const state = {
    dNone: 'd-none',
    noActive: 'no-active'
};

const getSectionsAnchor = ($sections) => $sections.map((index, item) => $(item).data('anchor'));

const initFullPage = () => {
    const $splash = $(selectors.splash);
    const $fullPageElement = $('#fullpage');
    const $sections = $(selectors.sections);
    const $arrowTop = $(selectors.arrowTop);
    const $arrowTopLink = $(selectors.arrowTopLink);
    const $arrowBottom = $(selectors.arrowBottom);
    const $arrowBottomLink = $(selectors.arrowBottomLink);
    const sectionsAnchor = getSectionsAnchor($sections);

    if (!$fullPageElement) {
        return;
    }

    const workWithFirstScreen = () => {
        $arrowTop.addClass(state.dNone);
        $arrowBottom.attr('data-menuanchor', sectionsAnchor[1]);
        $arrowBottomLink.attr('href', `#${sectionsAnchor[1]}`);
    };

    $fullPageElement.fullpage({
        autoScrolling: true,
        menu: '.menu',
        normalScrollElements: `${selectors.normalScrollItem}`,
        afterRender: () => {
            $splash.addClass(state.noActive);
            workWithFirstScreen();
        },
        onLeave(origin, destination) {
            if (destination === 1) {
                workWithFirstScreen();
            } else {
                $arrowTop.removeClass(state.dNone);
            }

            if (destination > 1 && destination < $sections.length) {
                $arrowTop.attr('data-menuanchor', sectionsAnchor[destination - 2]);
                $arrowTopLink.attr('href', `#${sectionsAnchor[destination - 2]}`);
                $arrowBottom.attr('data-menuanchor', sectionsAnchor[destination]);
                $arrowBottomLink.attr('href', `#${sectionsAnchor[destination]}`);
            }

            if ($sections.length === destination) {
                $arrowBottom.addClass(state.dNone);
                $arrowTop.attr('data-menuanchor', sectionsAnchor[destination - 2]);
                $arrowTopLink.attr('href', `#${sectionsAnchor[destination - 2]}`);
            } else {
                $arrowBottom.removeClass(state.dNone);
            }
        }
    });
};

export default initFullPage;
